import { Box, Typography } from "@mui/material";
import { backdropInstructionInfo } from "../../utils/CommonUtils/constants";
import { useState, useRef, useEffect } from "react";
import useTranslationSetup from "../../utils/useTranslationSetup";
import Backdrop from "@mui/material/Backdrop";
import "./styles.css";

const InstructionBackdrop = ({ openBackdrop, setOpenBackdrop }) => {
  const [countDown, setCountDown] = useState(3);
  const intervalRef = useRef(null); // Reference to the interval
  const { t, activeLanguage } = useTranslationSetup();

  const handleClose = () => {
    setOpenBackdrop(false);
    clearInterval(intervalRef.current);
  };

  const handleOpen = () => {
    setOpenBackdrop(true);
    setCountDown(3); // Reset the countdown
    intervalRef.current = setInterval(() => {
      setCountDown((prevCount) => prevCount - 1);
    }, 2000);
  };

  useEffect(() => {
    if (openBackdrop) {
      handleOpen();
    }
  }, [openBackdrop]);

  useEffect(() => {
    if (countDown === 0) {
      clearInterval(intervalRef.current);
      handleClose();
    }
  }, [countDown]);

  return (
    <Backdrop className="instruction-backrop-container" open={openBackdrop}>
      {countDown !== 0 && (
        <Box className="backdrop-instruction-img-container">
          <img
            src={backdropInstructionInfo(t)[countDown].instructionImage}
            alt={backdropInstructionInfo(t)[countDown].instructionImageAlt}
            className="instruction-backrop-img"
          />
          <Typography
            fontSize={activeLanguage === "en" ? "32px" : "30px"}
            className="custom-ff-bold"
            lang={activeLanguage}
          >
            {backdropInstructionInfo(t)[countDown].instruction}
          </Typography>
          <Typography
            fontSize="80px"
            className="custom-ff-bold"
            lang={activeLanguage}
          >
            {countDown}
          </Typography>
        </Box>
      )}
    </Backdrop>
  );
};

export default InstructionBackdrop;
